// Libraries
var React = require('react');
var $ = require('jquery');

// Styles
require('./TrendingHero.scss');

// Components
var Checkbox = require('Checkbox/CheckboxModule');
var RestrictedComponent = require('RestrictedComponent/RestrictedComponent');
var { getLoginStatus } = require('Logon/Logon');

// Assets
var spinner = require('images/Rolling-white.svg')

class TrendingHeroModule extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			hasChanged: false,
			isFollowing: this.props.data.isFollowing,
			isLoggedIn: false,
			baseUrl: this.props.data.baseUrl,
			id: this.props.data.id,
			showFollow: false,
			hashTagTitle: this.props.data.hashtagTitle,
			defaultMParticleEventObject: window.defaultMParticleEventObject
		}
	}

	hasChanged = _ => {
		const url = this.state.baseUrl + (this.state.isFollowing ? '/unfollow/' : '/follow/') + '?id=' + this.state.id;
		this.setState({ isLoading: true});

		$.ajax(url)
			.done(_ => {
				this.setState({ hasChanged: true, isFollowing: !this.state.isFollowing });

				setTimeout(_ => {
					this.setState({ hasChanged: false });
				}, 3000);

				const topicName = this.state.hashTagTitle.replace('#', '');

				const eventData = {
					event: this.state.isFollowing ? 'topic_followed' : 'topic_unfollowed',
					topic_name: topicName
				};

				if (this.state.isFollowing) {

					if (!this.state.defaultMParticleEventObject.topics_followed) {

						this.state.defaultMParticleEventObject.topics_followed = [];

					}

					this.state.defaultMParticleEventObject.topics_followed.push(topicName);

				} else {

					const currentIndex = this.state.defaultMParticleEventObject.topics_followed.indexOf(topicName);
					if (currentIndex > -1) { this.state.defaultMParticleEventObject.topics_followed.splice(currentIndex, 1); }

					if (!this.state.defaultMParticleEventObject.topics_followed.length) {

						this.state.defaultMParticleEventObject.topics_followed = null;

					}

				}
				
				const eventDataMerged = {...this.state.defaultMParticleEventObject, ...eventData };

				window.dataLayer.push(eventDataMerged);

			})
			.always(_ => {
				this.setState({ isLoading: false });
			});
	}

	componentDidMount() {
		getLoginStatus()
			.then(result => {
				this.setState({
					isLoggedIn: result.isLoggedIn,
					showFollow: this.props.data.showFollow && window.spurs_login_data.enabled
				});
			})
			.catch(err => {
				console.error('Login status fetch failed:', err);
			});
	}

	render() {
		const images = this.props.data.image;

		return (
			<div data-bg={images.smallUrl + '*,*' + images.mediumUrl + '*,*' + images.largeUrl + '*,*' + images.extraLargeUrl} ref={(hero) => { this.hero = hero; }} className="TrendingHero">
				<div className="TrendingHero__wrapper">
					<h1>{this.props.data.hashtagTitle}</h1>
					<p>{this.props.data.subTitle}</p>
					{this.state.showFollow &&
						<RestrictedComponent hasAccess={this.state.isLoggedIn} isVideo={false} className="trending">
							<Checkbox checked={this.state.isFollowing} callback={this.hasChanged} labelUnchecked="Follow" labelChecked="Unfollow" id="trendinghero">
								{this.state.isLoading &&
									<img src={spinner} className="spinner" alt="Loading animation" />
								}
							</Checkbox>
						</RestrictedComponent>
					}
					<p className={"flash-message" + (this.state.hasChanged ? " show" : "")}>{this.state.isFollowing ?
						"You have followed this tag and added it to My Tags" :
						"You have unfollowed this tag and removed it from My Tags"
					}</p>
				</div>
			</div>
		)
	}
}

module.exports = TrendingHeroModule;



// WEBPACK FOOTER //
// ./src/components/Hero/TrendingHero/TrendingHeroModule.js